
import { Injectable } from "@angular/core";
import { ModelBaseService } from './base/modelBase.service';
import { BaseService } from "./base/base.service";
import {IPayment} from "../models/payment"
import { LocalStorageService } from "./base/localStorage.service";
import { Observable, catchError, switchMap, throwError } from "rxjs";

@Injectable({
    providedIn: 'root'
  })

export class PaymentService extends ModelBaseService<IPayment> {
  
    constructor(public baseService: BaseService,private localStorageService: LocalStorageService) {
        super(`payments`,baseService);
    }

    getPaymentsByUser(): Observable<any> {
        return this.localStorageService.getCurrentUser().pipe(
          switchMap((result: any) => {
            if (result && result._id) {
              return this.baseService.getOne('payments/candidate', result._id);
            } else {
              throw new Error('User not found or missing ID');
            }
          }),
          catchError(error => {
            // Gérer les erreurs ici
            return throwError(error);
          })
        );
      }
   
}
